const findBankOfficeRu = {
  'findBankOffice': 'Найти офис банка',
};

export default findBankOfficeRu;
